import _ from 'lodash';
import { AllPlans } from '@/plans';
import { getOnlinePlanName } from '@/common/product';
import { planTypes } from '@/common/constants';
import { dateTimeFormatWithClientZone } from '@/utils/dateformat';
import { BaseCouponErrorHandler } from '@zoom/billing-coupon';
import { translation } from '@/plugins/i18n';

const supportPlanTypeList = _.chain(AllPlans)
  .filter((p) => p?.components?.config)
  .map((p) => planTypes[p.key])
  .value();

export class CouponErrorHandler extends BaseCouponErrorHandler {
  constructor(couponResult = {}, planList = []) {
    super(couponResult, planList, supportPlanTypeList);
  }

  getOnlinePlanName(plan, { isNeedBillingCycle }) {
    const planName = getOnlinePlanName(plan, true);
    const billingCycle = (isNeedBillingCycle && plan?.billing_cycle)
      ? _.upperFirst(translation(`billing.cycle.${plan.billing_cycle}`)) : '';

    return `${planName}${billingCycle ? ` ${billingCycle}` : ''}`;
  }

  dateTimeFormat(t) {
    return dateTimeFormatWithClientZone(t);
  }
}
